import { render, staticRenderFns } from "./lkuExpLazzy.vue?vue&type=template&id=6505e66c&"
import script from "./lkuExpLazzy.vue?vue&type=script&lang=js&"
export * from "./lkuExpLazzy.vue?vue&type=script&lang=js&"
import style0 from "./lkuExpLazzy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports